var map = {
	"./1-game-cover/cover-background.bak.json": 132,
	"./1-game-cover/cover-background.json": 133,
	"./game-compass/game2-cover-background.json": 134,
	"./game-compass/game2-fail-background.json": 135,
	"./game-compass/game2-success-background.json": 136,
	"./game-gunpowder/game4-cover-background.json": 137,
	"./game-gunpowder/game4-fail-background.json": 138,
	"./game-gunpowder/game4-success-background.json": 139,
	"./game-paper-making/game1-cover-background.json": 140,
	"./game-paper-making/game1-fail-background.json": 141,
	"./game-paper-making/game1-step1.json": 142,
	"./game-paper-making/game1-step2.json": 143,
	"./game-paper-making/game1-step3.json": 144,
	"./game-paper-making/game1-step4.json": 145,
	"./game-paper-making/game1-step5.json": 146,
	"./game-paper-making/game1-step6.json": 147,
	"./game-paper-making/game1-success-background.json": 148,
	"./game-printing/game3-cover-background.json": 149,
	"./game-printing/game3-fail-background.json": 150,
	"./game-printing/game3-success-background.json": 151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;